import type { ValueOf } from '@shared/lib'

export const BadgeVariant = {
  gray: 'gray',
  green: 'green',
  orange: 'orange',
  red: 'red',
  violet: 'violet',
  blue: 'blue',
} as const

export type BadgeVariant = ValueOf<typeof BadgeVariant>
